



export function skipToMainContentBtn_focus(event) {
    $w('#skipToMainContentBtn').onMouseIn(skipToContent);
}
function skipToContent(e) {
    console.log("Changed");
    $w('#uploadButton1').scrollTo();
}